import React from 'react'
import Homepage from './components/homepage';

function App() {
  return (
  
    <div className="App">
      <title>Ayyappa Bhakta Samaj</title>
      <Homepage />
    </div>
  );
}

export default App;
